import SigliveServiceSSE from 'Service/sigliveServiceSSE';

const getHostStockList = async (queries = '') => {
  const { data } = await SigliveServiceSSE({ method: 'GET', url: `/productivity-host/stock/list?${queries}` });

  return data;
};

export default getHostStockList;
